export interface Actor {
  id: string;
  name: string;
  initial: string;
  avatar: string;
  region: string;
  birth: string;
  tags: string[];
  bio: string;
  dramaIds: string[];
}

export const actors: Actor[] = [
  {
    id: 'lin-che',
    name: '林澈',
    initial: 'L',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20mature%20asian%20man%20in%20a%20dark%20coat%2C%20deep%20charcoal%20background%20with%20subtle%20red%20rim%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-lin-che&orientation=portrait',
    region: '中国大陆',
    birth: '1988-03-12',
    tags: ['实力派', '都市', '情感'],
    bio: '林澈以克制而富有层次的表演见长，擅长诠释内心复杂的中年男性角色。入行十余年，他在舞台与镜头之间不断打磨演技，被认为是最能"用沉默演戏"的演员之一。',
    dramaIds: ['late-night-neon', 'museum-lost-love', 'beneath-neon', 'last-subway'],
  },
  {
    id: 'su-wan',
    name: '苏晚',
    initial: 'S',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elegant%20mature%20asian%20woman%20with%20dark%20hair%2C%20deep%20charcoal%20background%20with%20a%20touch%20of%20burgundy%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-su-wan&orientation=portrait',
    region: '中国大陆',
    birth: '1990-07-25',
    tags: ['气质', '爱情', '都市'],
    bio: '苏晚的气场冷静而锋利，常在爱情与悬疑题材中挑大梁。她对角色心理的细腻把握，让每一个"独立的成年人"都显得真实可信。',
    dramaIds: ['late-night-neon', 'red-lip-contract', 'rose-apartment', 'dangerous-liaison', 'two-faced-lover'],
  },
  {
    id: 'chen-mo',
    name: '陈默',
    initial: 'C',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20serious%20mature%20asian%20man%20with%20sharp%20features%2C%20dark%20charcoal%20background%20with%20cool%20red%20edge%20light%2C%20moody%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-chen-mo&orientation=portrait',
    region: '中国大陆',
    birth: '1985-11-02',
    tags: ['悬疑', '犯罪', '实力派'],
    bio: '陈默是悬疑与犯罪题材的常客，眉宇间的沉郁气质让他成为"沉默主角"的不二人选。他坚持在每一个细节里寻找人物的动机。',
    dramaIds: ['silent-witness', 'midnight-clinic', 'beneath-neon', 'city-boundary'],
  },
  {
    id: 'he-man',
    name: '何曼',
    initial: 'H',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20confident%20mature%20asian%20woman%20in%20a%20dark%20blazer%2C%20deep%20charcoal%20background%20with%20warm%20red%20accent%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-he-man&orientation=portrait',
    region: '中国大陆',
    birth: '1992-01-18',
    tags: ['女性题材', '剧情', '导演'],
    bio: '何曼既是演员也是导演，作品多聚焦都市女性的处境与选择。她的镜像语言冷静克制，被评价为"最懂成年人沉默"的创作者之一。',
    dramaIds: ['silent-witness', 'midnight-clinic', 'beneath-neon', 'peach-mystery'],
  },
  {
    id: 'gu-yan',
    name: '顾言',
    initial: 'G',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20charming%20mature%20asian%20man%20with%20a%20slight%20smile%2C%20dark%20charcoal%20background%20with%20warm%20amber%20and%20red%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-gu-yan&orientation=portrait',
    region: '中国大陆',
    birth: '1987-09-09',
    tags: ['都市', '幽默', '多面'],
    bio: '顾言戏路宽广，既能演出都市精英的锋利，也能驾驭轻喜剧的松弛。他相信"好角色不分正喜，只看是否真诚"。',
    dramaIds: ['late-night-neon', 'city-boundary', 'dangerous-liaison', 'peach-mystery'],
  },
  {
    id: 'wen-ning',
    name: '温宁',
    initial: 'W',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20gentle%20mature%20asian%20woman%20with%20soft%20expression%2C%20dark%20charcoal%20background%20with%20subtle%20wine%20red%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-wen-ning&orientation=portrait',
    region: '中国大陆',
    birth: '1993-05-30',
    tags: ['文艺', '治愈', '情感'],
    bio: '温宁以温柔的银幕气质著称，擅长诠释内敛而坚韧的女性。她的表演像一面安静的镜子，让观众看见自己不愿言说的部分。',
    dramaIds: ['city-boundary', 'rose-apartment', 'midnight-clinic', 'last-subway'],
  },
  {
    id: 'bai-wei',
    name: '白薇',
    initial: 'B',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20striking%20mature%20asian%20woman%20with%20bold%20style%2C%20deep%20charcoal%20background%20with%20strong%20crimson%20rim%20light%2C%20dramatic%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-bai-wei&orientation=portrait',
    region: '中国大陆',
    birth: '1991-12-11',
    tags: ['气场', '爱情', '悬疑'],
    bio: '白薇的存在感极强，往往一出场就能定住整场戏的基调。她在爱情与悬疑之间自由切换，被称为"最有故事感的眼睛"。',
    dramaIds: ['red-lip-contract', 'rose-apartment', 'museum-lost-love', 'two-faced-lover', 'peach-mystery'],
  },
  {
    id: 'lu-chen',
    name: '陆沉',
    initial: 'L',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20intense%20mature%20asian%20man%20with%20dark%20eyes%2C%20deep%20charcoal%20background%20with%20cool%20burgundy%20light%2C%20moody%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-lu-chen&orientation=portrait',
    region: '中国大陆',
    birth: '1986-06-21',
    tags: ['魅力', '情感', '悬疑'],
    bio: '陆沉擅长演绎心思深沉的复杂角色，眼神里的分寸感让"城府"与"深情"可以同时成立。他是情感博弈类短剧的首选男主。',
    dramaIds: ['red-lip-contract', 'dangerous-liaison', 'two-faced-lover'],
  },
  {
    id: 'ji-ang-feng',
    name: '江枫',
    initial: 'J',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20mature%20asian%20man%20with%20a%20calm%20gaze%2C%20dark%20charcoal%20background%20with%20warm%20red%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-jiang-feng&orientation=portrait',
    region: '中国大陆',
    birth: '1994-08-14',
    tags: ['新生代', '治愈', '文艺'],
    bio: '江枫是新锐演员中少见的"安静型"表演者，擅长用细微的表情传达复杂情绪。他被视为成人向文艺短剧的希望之星。',
    dramaIds: ['last-subway', 'museum-lost-love', 'silent-witness'],
  },
  {
    id: 'xi-qinghuan',
    name: '许清欢',
    initial: 'X',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20refined%20mature%20asian%20woman%20with%20elegant%20features%2C%20deep%20charcoal%20background%20with%20a%20soft%20red%20glow%2C%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-xu-qinghuan&orientation=portrait',
    region: '中国大陆',
    birth: '1989-02-07',
    tags: ['导演', '艺术', '剧情'],
    bio: '许清欢身兼导演与编剧，作品以强烈的视觉风格和冷静的叙事节奏著称。她坚持"短剧也要有电影级的表达"。',
    dramaIds: ['red-lip-contract', 'beneath-neon'],
  },
  {
    id: 'shen-yu',
    name: '沈屿',
    initial: 'S',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20thoughtful%20mature%20asian%20man%20with%20glasses%2C%20dark%20charcoal%20background%20with%20cool%20red%20edge%20light%2C%20moody%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-shen-yu&orientation=portrait',
    region: '中国大陆',
    birth: '1984-10-26',
    tags: ['导演', '现实', '都市'],
    bio: '沈屿是现实题材的代表导演之一，善于在克制中积累情绪。他相信城市的质感，来自每一个被忽略的普通人。',
    dramaIds: ['city-boundary', 'last-subway', 'midnight-clinic'],
  },
  {
    id: 'zhou-yutang',
    name: '周雨棠',
    initial: 'Z',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20lively%20mature%20asian%20woman%20with%20a%20warm%20smile%2C%20dark%20charcoal%20background%20with%20warm%20amber%20and%20red%20light%2C%20soft%20studio%20lighting%2C%20film%20grain%2C%20editorial%20headshot%2C%20high%20detail%2C%20no%20text&width=500&height=640&seq=actor-zhou-yutang&orientation=portrait',
    region: '中国大陆',
    birth: '1995-04-03',
    tags: ['喜剧', '轻快', '新生代'],
    bio: '周雨棠的表演自带松弛的喜感，擅长在轻喜剧里塑造鲜活的都市女性。她的节奏感被认为是短剧喜剧题材的关键。',
    dramaIds: ['peach-mystery', 'rose-apartment'],
  },
];